// extracted by mini-css-extract-plugin
export default {"tableButton":"Buttons_tableButton__wBvpc","passwordBtn":"Buttons_passwordBtn__teJXJ","navigationBtn":"Buttons_navigationBtn__2IXMp"};